import { createActions } from 'redux-actions';

const actions = createActions({
  ALL_PETS_GROUPED: (data) => data,
  CANCEL_MULTIBRAND_POLICY: (data) => data,
  CANCEL_MULTIBRAND_POLICY_ERROR: () => { },
  CANCEL_MULTIBRAND_POLICY_SUCCESS: () => { },
  CANCEL_RENEWAL_MODAL_VISIBLE_CHANGED: (data) => data,
  CHANGE_COVERAGE_MULTIMODAL_FAILED: (data) => data,
  CHANGE_COVERAGE_MULTIMODAL_LOADED: (data) => data,
  CHANGE_COVERAGE_PREVIEW_LOADED: (data) => data,
  CHANGE_DEDUCTIBLE_LEGEND: (data) => data,
  CLEAR_POLICY_NOTIFICATIONS: () => { },
  COVERAGE_TYPE_CHANGED: (data) => data,
  DEDUCTIBLE_CHANGED: (data) => data,
  GET_CHANGE_COVERAGE_MULTIMODAL: (data) => data,
  GET_CHANGE_COVERAGE_PREVIEW: (data) => data,
  GET_CHANGE_COVERAGE_PREVIEW_ERROR: () => { },
  GET_COVERAGE_PERIOD_FAILURE: (data) => data,
  GET_COVERAGE_PERIOD_REQUEST: (data) => data,
  GET_COVERAGE_PERIOD_RESET: (data) => data,
  GET_COVERAGE_PERIOD_SUCCESS: (data) => data,
  GET_COVERAGE_QUOTE_PRODUCT_FAILED: (data) => data,
  GET_COVERAGE_QUOTE_PRODUCT_SUCCESS: (data) => data,
  GET_HAS_CARE_CREDIT_URL: () => { },
  GET_HAS_CARE_CREDIT_URL_FAILED: () => { },
  GET_HAS_CARE_CREDIT_URL_SUCCESS: (data) => data,
  GET_MULTIBRAND_DEFAULT_POLICY: (data) => data,
  GET_MULTIBRAND_DEFAULT_POLICY_ERROR: () => { },
  GET_MULTIBRAND_DEFAULT_POLICY_LOADED: (data) => data,
  GET_MULTIBRAND_POLICIES: () => { },
  GET_MULTIBRAND_POLICIES_ERROR: () => { },
  GET_MULTIBRAND_POLICIES_LOADED: (data) => data,
  GET_ORCA_COVERAGE_PREVIEW: (data) => data,
  GET_ORCA_COVERAGE_PREVIEW_FAILED: () => { },
  GET_ORCA_COVERAGE_PREVIEW_SUCCESS: (data) => data,
  GET_POLICY_DETAIL: (data) => data,
  GET_POLICY_DETAIL_ERROR: () => { },
  GET_POLICY_DETAIL_LOADED: (data) => data,
  GET_PROXY_POLICY: (data) => data,
  GET_PROXY_POLICY_FAILED: () => { },
  GET_PROXY_POLICY_SUCCESS: (data) => data,
  GET_WAITING_PERIODS: (data) => data,
  INITIAL_POWER_UPS: (data) => data,
  LOAD_MULTI_MODAL_DATA: (data) => data,
  LOAD_PLAN_SUMMARY_SEE_MORE_INFO: (data) => data,
  LOAD_PLAN_SUMMARY_SEE_MORE_INFO_ATTEMPT: () => { },
  LOAD_POLICIES_OVERVIEW: () => { },
  LOAD_POLICY_NOTIFICATIONS: (data) => data,
  LOAD_WHAT_WE_COVER_INFO: (data) => data,
  LOAD_WHAT_WE_COVER_INFO_ATTEMPT: () => { },
  LOGGED_IN_WITHOUT_PETS_RESET: () => { },
  MULTI_MODAL_DATA_LOADED: (data) => data,
  PETS_GROUPED: (data) => data,
  PLAN_SUMMARY_SEE_MORE_CLICKED: (data) => data,
  PLAN_SUMMARY_SEE_MORE_INFO_LOADED: (data) => data,
  POLICIES_ERROR: (data) => data,
  POLICIES_OVERVIEW_LOADED: (data) => data,
  POLICY_DETAIL_CLEANED: () => { },
  POLICY_NOTIFICATIONS_LOADED: (data) => data,
  POWER_UP_SELECTED: (data) => data,
  QUOTE_POWER_UP_CHANGED: (data) => data,
  QUOTE_TOTAL_RECALCULATED: (data) => data,
  RATE_COVERAGE: (data) => data,
  RATE_COVERAGE_ERROR: () => { },
  RATE_COVERAGE_SUCCESS: (data) => data,
  RATE_QUOTE_UPDATE_ATTEMPT: (data) => data,
  RATE_QUOTE_UPDATE_LOADED: (data) => data,
  REFRESH_POLICIES: () => { },
  REIMBURSEMENT_CHANGED: (data) => data,
  REQUEST_CANCEL_RENEWAL: (data) => data,
  REQUEST_CANCEL_RENEWAL_FAILED: () => { },
  REQUEST_CANCEL_RENEWAL_SUCCESS: (data) => data,
  RESET_CHANGE_COVERAGE_ORCA: () => { },
  RESTART_RATE: () => { },
  REVIEW_CHANGES_VISIBLE_CHANGED: (data) => data,
  SAVE_ORCA_QUOTE: (data) => data,
  SAVE_ORCA_QUOTE_FAILED: () => { },
  SAVE_ORCA_QUOTE_RESET: () => { },
  SAVE_ORCA_QUOTE_SUCCESS: (data) => data,
  SELECTED_PLAN_CHANGED: (data) => data,
  STORE_ALL_POLICIES: (data) => data,
  STORE_POLICIES: (data) => data,
  SUBMIT_CHANGE_COVERAGE: (data) => data,
  SUBMIT_CHANGE_COVERAGE_FAILED: () => { },
  SUBMIT_CHANGE_COVERAGE_SUCCESS: () => { },
  SUBMIT_COVERAGE_PERIOD: (data) => data,
  SUBMIT_COVERAGE_PERIOD_FAILED: () => { },
  SUBMIT_COVERAGE_PERIOD_SUCCESS: (data) => data,
  UPDATE_POWER_UP: (data) => data,
  VALIDATE_CHANGE_COVERAGE: (data) => data,
  VALIDATE_CHANGE_COVERAGE_CLEARED: (data) => data,
  VALIDATE_CHANGE_COVERAGE_FAILED: (data) => data,
  VALIDATE_CHANGE_COVERAGE_SUCCESS: (data) => data,
  WAITING_PERIODS_LOADED: (data) => data,
  WHAT_WE_COVER_INFO_LOADED: (data) => data,
  YOUNG_PET_MODAL_CLOSED: () => { },
  YOUNG_PET_MODAL_OPEN: () => { },
});

export const {
  allPetsGrouped,
  cancelMultibrandPolicy,
  cancelMultibrandPolicyError,
  cancelMultibrandPolicySuccess,
  cancelRenewalModalVisibleChanged,
  changeCoverageMultimodalFailed,
  changeCoverageMultimodalLoaded,
  changeCoveragePreviewLoaded,
  changeDeductibleLegend,
  clearPolicyNotifications,
  coverageTypeChanged,
  deductibleChanged,
  getChangeCoverageMultimodal,
  getChangeCoveragePreview,
  getChangeCoveragePreviewError,
  getCoveragePeriodFailure,
  getCoveragePeriodRequest,
  getCoveragePeriodReset,
  getCoveragePeriodSuccess,
  getCoverageQuoteProductFailed,
  getCoverageQuoteProductSuccess,
  getHasCareCreditUrl,
  getHasCareCreditUrlFailed,
  getHasCareCreditUrlSuccess,
  getMultibrandDefaultPolicy,
  getMultibrandDefaultPolicyError,
  getMultibrandDefaultPolicyLoaded,
  getMultibrandPolicies,
  getMultibrandPoliciesError,
  getMultibrandPoliciesLoaded,
  getOrcaCoveragePreview,
  getOrcaCoveragePreviewFailed,
  getOrcaCoveragePreviewSuccess,
  getPolicyDetail,
  getPolicyDetailError,
  getPolicyDetailLoaded,
  getProxyPolicy,
  getProxyPolicyFailed,
  getProxyPolicySuccess,
  getWaitingPeriods,
  initialPowerUps,
  loadMultiModalData,
  loadPlanSummarySeeMoreInfo,
  loadPlanSummarySeeMoreInfoAttempt,
  loadPoliciesOverview,
  loadPolicyNotifications,
  loadWhatWeCoverInfo,
  loadWhatWeCoverInfoAttempt,
  loggedInWithoutPetsReset,
  multiModalDataLoaded,
  petsGrouped,
  planSummarySeeMoreClicked,
  planSummarySeeMoreInfoLoaded,
  policiesError,
  policiesOverviewLoaded,
  policyDetailCleaned,
  policyNotificationsLoaded,
  powerUpSelected,
  quotePowerUpChanged,
  quoteTotalRecalculated,
  rateCoverage,
  rateCoverageError,
  rateCoverageSuccess,
  rateQuoteUpdateAttempt,
  rateQuoteUpdateLoaded,
  refreshPolicies,
  reimbursementChanged,
  requestCancelRenewal,
  requestCancelRenewalFailed,
  requestCancelRenewalSuccess,
  resetChangeCoverageOrca,
  restartRate,
  reviewChangesVisibleChanged,
  saveOrcaQuote,
  saveOrcaQuoteFailed,
  saveOrcaQuoteReset,
  saveOrcaQuoteSuccess,
  selectedPlanChanged,
  storeAllPolicies,
  storePolicies,
  submitChangeCoverage,
  submitChangeCoverageFailed,
  submitChangeCoverageSuccess,
  submitCoveragePeriod,
  submitCoveragePeriodFailed,
  submitCoveragePeriodSuccess,
  updatePowerUp,
  validateChangeCoverage,
  validateChangeCoverageCleared,
  validateChangeCoverageFailed,
  validateChangeCoverageSuccess,
  waitingPeriodsLoaded,
  whatWeCoverInfoLoaded,
  youngPetModalClosed,
  youngPetModalOpen,
} = actions;
